import internalApiClient from '~/app/shared/util/api/internalApiClient';

export const getPeppolIdValue = async (country: string | undefined, cvr: string | undefined): Promise<string | undefined> => {
    if (!country || !cvr) {
        return undefined;
    }

    try {
        const response = await internalApiClient.get(
            `/electronic-invoicing/sending/peppol/org-identifier?country=${country}&cvr=${cvr}`
        );
        return response.data;
    } catch {
        return undefined;
    }
};
